import type { FloodData } from "@/types/public-data"

interface FloodCardProps {
  data: FloodData
}

export default function FloodCard({ data }: FloodCardProps) {
  // Deduplicate stations by label (API can return multiple entries for the same station)
  const uniqueStations = data.stations.reduce<typeof data.stations>((acc, station) => {
    if (!acc.some((s) => s.label === station.label)) {
      acc.push(station)
    }
    return acc
  }, [])

  return (
    <div className="rounded-xl border border-stone bg-white p-6">
      <h3 className="font-display text-lg font-semibold text-charcoal">
        Flood Risk
      </h3>

      <div className="mt-3 flex items-center gap-2">
        <span
          className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-medium ${
            data.hasActiveWarnings
              ? "bg-red/5 text-red"
              : "bg-stone text-charcoal"
          }`}
        >
          {data.hasActiveWarnings ? "Active warnings" : "No active warnings"}
        </span>
      </div>

      <p className="mt-3 text-sm text-slate">
        {data.stationCount} monitoring{" "}
        {data.stationCount === 1 ? "station" : "stations"} nearby
      </p>

      {uniqueStations.length > 0 && (
        <ul className="mt-3 space-y-1.5">
          {uniqueStations.slice(0, 6).map((station) => (
            <li
              key={station.label}
              className="flex items-center gap-2 text-sm"
            >
              <span className="size-1.5 shrink-0 rounded-full bg-slate/40" />
              <span className="text-charcoal">{station.label}</span>
              {station.riverName && (
                <span className="text-slate">({station.riverName})</span>
              )}
            </li>
          ))}
          {uniqueStations.length > 6 && (
            <li className="pl-3.5 text-xs text-slate">
              and {uniqueStations.length - 6} more
            </li>
          )}
        </ul>
      )}
    </div>
  )
}
